import { push } from 'react-router-redux';
import { Dispatch } from 'redux';

import * as AccountRepository from 'repositories/account';

import { AccountActionCreators } from 'actions/account';
import { FlashMessageActionCreators } from 'actions/flashMessage';
import { LayoutActionCreators } from 'actions/layout';
import { ROUTE_INVOICE_PAGE_ALL } from 'constants/app';
import { handleGenericApiError } from 'helper/error';
import { compress } from 'helper/image';
import { Account, AccountStore, AccountStoreForm } from 'models/account';
import { Thunk } from 'models/redux';

export function registerStore(formValue: AccountStoreForm): Thunk {
  return (dispatch, getState) => {
    dispatch(LayoutActionCreators.showLoading.create());

    const normalizedForm = normalizeAccountStoreForm(formValue);
    AccountRepository.updateStore(normalizedForm)
      .then((updateStoreResponse) => {
        if (normalizedForm.avatar) {
          dispatch(uploadStoreAvatar(normalizedForm.avatar, (uploadAvatarResponse) => {
            handleStoreRegister({ ...getState().accountState.account }, uploadAvatarResponse, dispatch);
          }));
        } else {
          handleStoreRegister({ ...getState().accountState.account }, updateStoreResponse, dispatch);
        }
      })
      .catch((e) => {
        handleGenericApiError('action.failed.store.register', e, dispatch);
        dispatch(LayoutActionCreators.hideLoading.create());
        console.error(e); // tslint:disable-line
      });
  };
}

export function updateStore(formValue: AccountStoreForm): Thunk {
  return (dispatch, getState) => {
    dispatch(LayoutActionCreators.showLoading.create());

    const normalizedForm = normalizeAccountStoreForm(formValue);
    AccountRepository.updateStore(normalizedForm)
      .then((updateStoreResponse) => {
        if (normalizedForm.avatar && normalizedForm.avatar.size > 0) {
          dispatch(uploadStoreAvatar(normalizedForm.avatar, (uploadAvatarResponse) => {
            handleStoreUpdate({ ...getState().accountState.account }, uploadAvatarResponse, dispatch);
          }));
        } else {
          handleStoreUpdate({ ...getState().accountState.account }, updateStoreResponse, dispatch);
        }
      })
      .catch((e) => {
        handleGenericApiError('action.failed.store.update', e, dispatch);
        dispatch(LayoutActionCreators.hideLoading.create());
        console.error(e); // tslint:disable-line
      });
  };
}

export function uploadStoreAvatar(avatar: File, successCallback: (store: AccountStore) => void): Thunk {
  return (dispatch, getState) => {
    compress(
      avatar,
      (compressResult) => {
        AccountRepository.uploadStoreAvatar(compressResult)
          .then((store) => {
            successCallback(store);
          })
          .catch((e) => {
            handleGenericApiError('action.failed.store.upload.avatar', e, dispatch);
            dispatch(LayoutActionCreators.hideLoading.create());
            console.error(e); // tslint:disable-line
          });
      },
      (error) => {
        dispatch(FlashMessageActionCreators.show.create({
          modifier: 'danger',
          text: 'action.failed.store.upload.avatar'
        }));
        dispatch(LayoutActionCreators.hideLoading.create());
        console.error(error); // tslint:disable-line
      }
    );
  };
}

function normalizeAccountStoreForm(formValue: AccountStoreForm) {
  if (formValue.url) {
    const appendedUrl = (!formValue.url.startsWith('http:') && !formValue.url.startsWith('https:')) ?
    `https://${formValue.url}` : formValue.url;
    return { ...formValue, url: appendedUrl };
  }

  return formValue;
}

function handleStoreRegister(account: Account, store: AccountStore, dispatch: Dispatch<void>) {
  const newAccount = { ...account, store: { ...store } };
  dispatch(AccountActionCreators.updateAccount.create(newAccount));
  dispatch(push(ROUTE_INVOICE_PAGE_ALL));
  dispatch(LayoutActionCreators.hideLoading.create());
}

function handleStoreUpdate(account: Account, store: AccountStore, dispatch: Dispatch<void>) {
  const newAccount = { ...account, store: { ...store } };
  dispatch(AccountActionCreators.updateAccount.create(newAccount));
  dispatch(FlashMessageActionCreators.show.create({
    modifier: 'success',
    text: 'action.success.store.update'
  }));
  dispatch(LayoutActionCreators.hideLoading.create());
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/actions/account/store.ts